<!-- 月度计划管理 -->
<template>
  <div>
    <!-- <matrix-statistics span="8" :list="infoCardData(cardData)"></matrix-statistics> -->
    <avue-crud ref="crud" v-model="form" :option="option" :table-loading="loading" :data="data" :page.sync="page" :search.sync="query" :defaults.sync="defaults" @row-save="rowSave" @row-update="rowUpdate" @row-del="rowDel"
      @search-change="searchChange" @search-reset="searchReset" @refresh-change="refreshChange" :beforeOpen="beforeOpen" @current-change="currentChange" @size-change="sizeChange" @on-load="onLoad" @selection-change="selectionChange">
      <template slot="menuLeft">
        <el-button type="danger" icon="el-icon-delete" plain size="small" :disabled="selectionList.length == 0" @click="handleDelete">批量删除</el-button>
      </template>
    </avue-crud>
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { getList, add, update, remove, getDetail } from "./api";
import { getSearchTimeConfig,rulesInput } from "@/basic-common/util/common";
import matrixStatistics from '@/components/matrix/matrix-statistics'
export default {
  components: { matrixStatistics },
  mixins: [crudMixins],
  data () {
    const that = this
    return {
      form: {},
      apiConfig: { getList, add, update, remove, getDetail },
      option: {
        ...this.$store.state.publicOption,
        column: [
          {
            label: '专家姓名',
            prop: 'expertName',
            overHidden: true, // 表格超出隐藏
            minWidth: 120,
            maxlength: 30,
            search: true,
            rules: rulesInput(1),
          },
          {
            label: '性别',
            prop: 'gender',
            search: true, // 查询是否显示
            overHidden: true, // 表格超出隐藏
            width: 80,
            type: 'select',
            dicData: [
              { label: '男', value: '1' },
              { label: '女', value: '2' }
            ],
            rules: rulesInput(2),
          },
          {
            label: '联系电话',
            prop: 'phone',
            overHidden: true, // 表格超出隐藏
            width: 130,
            type: 'input',
            maxlength: 11,
            placeholder: '请输入手机号码',
            rules: [
              { required: true, message: '请输入联系电话', trigger: 'blur' },
              { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
            ],
          },
          {
            label: '出生日期',
            prop: 'birthDate',
            type: 'date',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            overHidden: true, // 表格超出隐藏
            width: 120,
            pickerOptions: {
              disabledDate (time) {
                return time.getTime() > Date.now();
              }
            },
            rules: rulesInput(2),
          },
          {
            label: '级别类型',
            prop: 'levelType',
            search: true, // 查询是否显示
            overHidden: true, // 表格超出隐藏
            width: 120,
            type: 'select',
            dicData: [
              { label: '国家级', value: '1' },
              { label: '省级', value: '2' },
              { label: '市级', value: '3' },
              { label: '县级', value: '4' },
              { label: '其他', value: '5' }
            ],
            rules: rulesInput(2),
          },
          {
            label: '领域',
            prop: 'field',
            search: true, // 查询是否显示
            overHidden: true, // 表格超出隐藏
            width: 120,
            type: 'select',
            dicData: [
              { label: '安全生产', value: '1' },
              { label: '环境保护', value: '2' },
              { label: '交通运输', value: '3' },
              { label: '建筑工程', value: '4' },
              { label: '化工', value: '5' },
              { label: '电力', value: '6' },
              { label: '其他', value: '7' }
            ],
            rules: rulesInput(2),
          },
          {
            label: '专业方向',
            prop: 'specialty',
            overHidden: true, // 表格超出隐藏
            width: 150,
            type: 'input',
            maxlength: 50,
            placeholder: '请输入专业方向',
          },
          {
            label: '专长',
            prop: 'expertise',
            overHidden: true, // 表格超出隐藏
            width: 150,
            type: 'textarea',
            maxlength: 200,
            placeholder: '请输入专长描述',
            span: 24,
          },
          {
            label: '职称',
            prop: 'title',
            search: true, // 查询是否显示
            overHidden: true, // 表格超出隐藏
            width: 120,
            type: 'select',
            dicData: [
              { label: '教授', value: '1' },
              { label: '副教授', value: '2' },
              { label: '高级工程师', value: '3' },
              { label: '工程师', value: '4' },
              { label: '助理工程师', value: '5' },
              { label: '研究员', value: '6' },
              { label: '副研究员', value: '7' },
              { label: '其他', value: '8' }
            ],
            rules: rulesInput(2),
          },
          {
            label: '最高学历',
            prop: 'education',
            search: true, // 查询是否显示
            overHidden: true, // 表格超出隐藏
            width: 120,
            type: 'select',
            dicData: [
              { label: '博士', value: '1' },
              { label: '硕士', value: '2' },
              { label: '本科', value: '3' },
              { label: '专科', value: '4' },
              { label: '高中及以下', value: '5' }
            ],
            rules: rulesInput(2),
          },
          {
            label: '录入时间',
            prop: 'createTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            overHidden: true, // 表格超出隐藏
            width: 180,
            addDisplay: false,
            editDisplay: false,
          },
          {
            ...getSearchTimeConfig('录入时间', { type: 'datetimerange' }),
            paramsKey: ["createStartTime", "createEndTime"],
          },
        ]
      },
      defaultParams: {}
    }
  },
  computed: {
    infoCardData () {
      return function (cardData) {
        return [{
          label: '专家总数',
          value: cardData['totalExperts'],
          unit: ' 人',
        }, {
          label: '国家级专家',
          value: cardData['nationalExperts'],
          unit: ' 人',
        }, {
          label: '省级专家',
          value: cardData['provincialExperts'],
          unit: ' 人',
        }] // 卡片数据
      }
    }
  }
}
</script>
<style scoped lang="scss">
p {
  margin: 0;
}
</style>
